__webpack_require__.p = "/note-boardgames-react/";